import { render, staticRenderFns } from "./login-saml.vue?vue&type=template&id=28c61dd2"
import script from "./login-saml.vue?vue&type=script&lang=js"
export * from "./login-saml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports